import { BlurView } from 'expo-blur';
import { Pressable } from 'react-native';
import { ActivityIndicator } from "react-native-paper";
import { create } from 'zustand'
import { StyleSheet, withUnistyles } from 'react-native-unistyles';

const UniBlurView = withUnistyles(BlurView);

const useLoader = create((set) => ({
    isEnabled: false,
    allowDismissal: false,
    noSidebar: false,
    mask: false,
    enable: (allowDismissal, noSidebar, mask) => set(() => ({isEnabled: true, allowDismissal, noSidebar, mask})),
    disable: () => set(() => ({isEnabled: false, allowDismissal: false, noSidebar: false, mask: false}))
}))


const FullScreenLoader = () => {
    const { isEnabled, allowDismissal, disable, mask } = useLoader();

    return isEnabled ? (
        <UniBlurView intensity={mask ? 70 : 20} style={styles.loader}>
            <Pressable onPress={() => allowDismissal ? disable() : null} style={styles.pressable}>
                <ActivityIndicator animating size="large" />
            </Pressable>
        </UniBlurView>
    ) : <></>;
};

const styles = StyleSheet.create(({scheme}, rt) => ({
    pressable:{
        flex:1, 
        height:rt.screen.height, 
        width:rt.screen.width, 
        justifyContent:"center", 
        alignItems:"center"
    },
    loader: {
        position:"absolute",
        height:rt.screen.height, 
        width:rt.screen.width, 
        zIndex:1000000, 
        flex:1, 
        justifyContent:"center", 
        alignItems:"center", 
        backgroundColor:scheme == 'dark' ? "rgba(0,0,0,0.6)" : "rgba(255,255,255,0.6)"
    }
}))

export default useLoader; 
export {FullScreenLoader}